export default __webpack_public_path__ + "static/media/backToTop.d6a44af8.svg";